<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/system")
          i.fa.fa-desktop
          span.ml-1 {{ $t("ui.system") }}
      b-breadcrumb-item
        router-link(to="/system/iplist")
          i.far.fa-file
          span.ml-1 {{ $t("ui.iplist") }}
  div.row.mb-5
    div.col-md-12
      div.card
        div.card-header.p-2
          div.row
            div.col-md-12
              b-button.btn-brand(v-b-modal.addIP type="button" variant="primary" size="sm").mr-1
                i.fa.fa-plus
                span {{ $t("ui.add_ip") }}
        div.card-body.p-1
          .table-sm.table-hover.table-responsive
            table.table.b-table
              thead
                tr
                  th
                    span {{ $t('ui.ip_address') }}
                  th.text-center(width=80)
                    span {{ $t("ui.action") }}
                  th
                    span {{ $t("ui.remark") }}
                  th
                    span {{ $t("ui.action_by") }}
                  th.text-right(width=200)
                    span {{ $t("ui.created_on") }}
              tbody
                tr(v-for="(item, index) in ipList")
                  td
                    span {{ item.ip }}
                  td
                    .d-flex.align-items-center.justify-content-center
                      b-link.action-item.fa.fa-trash.text-danger(
                        href="javascript:;"
                        :title="$t('ui.delete')"
                        @click="onDelete(item)"
                        )
                  td
                    span {{ item.remark }}
                  td
                    span {{ item.updated_by }}
                  td.text-right
                    span {{ getDate(item.created_on) }}
    addip(@clicked="addIP" @failed="handleFailed")
    deleteip(ref="deleteip" :ip="deleteSelectedIP" @clicked="deleteIP" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import addip from "@/components/ip/addIP.vue";
import deleteip from "@/components/ip/deleteIP.vue";
import DebounceInput from "@/library/DebounceInput";
export default {
  components: {
    addip,
    deleteip,
    DebounceInput
  },
  data() {
    return {
      filterBy: "id",
      ipList: [],
      pageSearch: "",
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      deleteSelectedIP: ""
    };
  },
  computed: {
    accessRoles() {
      return this.$store.getters.accessRoles;
    }
  },
  mounted() {
    let url = config.ipListUrl();

    var json = {
      action_by: this.$store.getters.username,
      session_token: this.$store.getters.sessionToken,
      page_id: config.accessRoles.iplist
    };

    this.$http.post(url, json).then(
      function(response) {
        // Success
        try {
          if (response) {
            this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

            this.feedback.status = response.data.statusdesc;
            if (this.feedback.success == true) {
              this.ipList = response.data.tbl_ip_list;
            } else {
              if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          }
        } catch (error) {
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      },
      function(response) {
        // Error
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
        this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
      }
    );
  },
  methods: {
    getDate(dateTime) {
      let convertDateFormat = new this.$moment(dateTime).format("DD/MM/YYYY, HH:mm:ss");
      return convertDateFormat;
    },
    onDelete(e) {
      this.deleteSelectedIP = e.ip;
      this.$refs.deleteip.$refs.deleteIP.show();
    },
    addIP: function(ip, remark) {
      let newIP = {
        ip: ip,
        remark: remark,
        updated_by: this.$store.getters.username,
        created_on: new Date()
      };

      this.ipList.unshift(newIP);
      this.$helpers.showDialog(this.$t("ui.add_ip"), this.$t("message.success"), "success");
    },
    deleteIP: function(ip) {
      let i = this.ipList.map(iplist => iplist.ip).indexOf(ip);
      this.ipList.splice(i, 1);
      this.$helpers.showDialog(this.$t("ui.delete_ip"), this.$t("message.success"), "success");
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
